var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapePoligon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 254 196",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.348 196C125.341 196 151.466 189.233 171.155 194.06C175.155 195.041 179.272 195.552 183.474 195.552C222.352 195.552 253.868 151.777 253.868 97.7762C253.868 43.7757 222.352 0 183.474 0C148.583 0 119.621 35.2591 114.048 81.5244C113.364 87.2065 109.495 91.2875 105.348 91.2875C95.8553 91.2875 83.4523 82.0634 78.6589 70.6816C71.3371 53.2953 57.7526 41.6163 42.2038 41.6163C18.8955 41.6163 0 67.8618 0 100.238C0 132.613 18.8955 158.859 42.2038 158.859C53.9187 158.859 70.4957 169.38 78.8164 180.834C85.628 190.209 95.0011 196 105.348 196Z",
    fill: "url(#paint0_radial_932_311)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_932_311",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3302 113.215) rotate(-8.23381) scale(268.719 57.0863)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.230625,
    stopColor: "#FF3BD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627709,
    stopColor: "#7B1BF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070710",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapePoligon);
export default __webpack_public_path__ + "static/media/shape_poligon.b88f7c77784e4bf098133f7ea1a9a503.svg";
export { ForwardRef as ReactComponent };